import { EnvironmentProviders } from '@angular/core';
import { provideIotPlatformApplicationState, provideIotPlatformBusinessProfileWhenReadRuleOnDeviceConfiguratorConceptState } from '@iot-platform/data-access';

export * from './lib/services';

export function provideXmqttApplicationState(): EnvironmentProviders[] {
  return [].concat(provideIotPlatformApplicationState(), provideIotPlatformBusinessProfileWhenReadRuleOnDeviceConfiguratorConceptState());
}
